import React from 'react';
import { Table, TableContainer, TableRow, TableHead, TableCell, Paper, TableBody, makeStyles } from '@material-ui/core';
import settings from '../../settings';

interface AnalyticsListProps {
    name: string,
    data: any[],
}

const useStyles = makeStyles((theme) => ({
    container: {
        display: "block",
        height: "80vh"
    },
    title: {
        margin: '1rem'
    }
}));

const AnalyticsList = (props: AnalyticsListProps) => {
    const style = useStyles();

    return <TableContainer component={Paper} className={style.container}>
        <Table aria-label="simple table" stickyHeader>
            <TableHead>
                <h2 className={style.title}>{props.name}</h2>
                <TableRow>
                    <TableCell>Titre</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.data.map((e, i) => (
                    <TableRow>
                        <TableCell>
                            <a href={`${settings.frontUrl}article/${e.type}/${e.data.slug}`}>
                                {e.data.title}
                            </a>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
}

export default AnalyticsList;